import React from 'react';
import {
  FDListItem, FDListItemText, FDList,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';

export const InfoBoxDetailList = (props) => {
  const { value } = props;
  if (!value || value.length < 1) {
    return null;
  }

  return (
    <FDList>
      {value.map((d, i) => (
        <FDListItem
          key={i} // eslint-disable-line react/no-array-index-key -- we have nothing better than the array index to use here
        >
          <FDListItemText primaryText={d} />
        </FDListItem>))}
    </FDList>
  );
};

InfoBoxDetailList.propTypes = {
  value: PropTypes.array.isRequired,
};
